import { configureStore } from '@reduxjs/toolkit'
import { enableMapSet } from 'immer'

import managerSlice from '../slices/managerSlice'

enableMapSet();

export const store = configureStore({
    reducer: {
        manager: managerSlice,
      },
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        })
})
